import ClearableSelect from "./ClearableSelect";

export default function UserActiveStatusFilter({
  param = "active",
  deleteParams = ["active"],
}) {
  const options = [
    { value: "true", label: "AllActiveUsers" },
    { value: "false", label: "AllInactiveUsers" },
  ];

  return (
    <ClearableSelect
      param={param}
      deleteParams={deleteParams}
      label="Status"
      options={options}
      testId="users.page.filters.status-select"
    />
  );
}
